define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require ("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var AgentGroupListLayout = require("user-management-views/agent-groups/AgentGroupListLayout");
    var AgentGroupsGridView = require("user-management-views/agent-groups/AgentGroupsGridView");
    var AgentGroupsGridModel = require("user-management-models/AgentGroupsGridModel");
    var AgentGroupListFilters = require("user-management-filters/AgentGroupListFilters");
    var AgentGroupListComparators = require("user-management-comparators/AgentGroupListComparators");
    var UserManagementUtilities = require("user-management-utils/UserManagementUtilities");
    var SecureUtilities = require("infra-util/SecureUtilities");

    var NAME_COMPARATOR = "name";
    var ASC_ORDERBY = "asc";
    var DEFAULT_COMPARATOR = NAME_COMPARATOR;
    var DEFAULT_ORDERBY = ASC_ORDERBY;
    var PAGE_SIZE = 25;

    var AgentGroupListController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupListController = Marionette.Controller.extend({
            dataInitialized: false,
            viewInitialized: false,
            initialize: function (options) {
                this._initialize(options);
            },
            getView: function () {
                return this._getView();
            },
            onNavigateOut: function(){
                this._onNavigateOut();
            },



            _initialize: function (options) {
                LEUserManagement.logger.debug("_initialize", "AgentGroupListController:_initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_LIST);
                this.agentGroupsGridModel = new AgentGroupsGridModel();
                this._bindEventsChannel();
            },

            _bindEventsChannel: function() {
                LEUserManagement.logger.debug("_bindEventsChannel", "AgentGroupListController:_bindEventsChannel");

                this.listenTo(this.channel, "paging:change", this._onPagingChange);
                this.listenTo(this.channel, "row:selector:click", this._onRowSelectorClick);
                this.listenTo(this.channel, "row:click", this._onRowClick);
                this.listenTo(this.channel, "actionMenu:select", this._onActionMenuSelect);
                this.listenTo(this.channel, "agentGroups:list:createNew", this._onAddSelected);
                this.listenTo(this.channel, "deselectModel", this._deselectModel);

                this.listenTo(LEUserManagement.vent, "agentGroupList:resetList", this._deselectModel);
            },

            _getView: function() {
                LEUserManagement.logger.debug("_getView", "AgentGroupListController:_getView");
                this._unbindEventsDataAndViews();
                this._initData();
                this._initViews();
                this._bindEventsDataAndViews();
                return this.agentGroupsListLayout;
            },

            _initData: function() {
                LEUserManagement.logger.debug("_initData", "AgentGroupListController:_initData");
                if (!this.dataInitialized) {
                    LEUserManagement.logger.debug("Initializing controller data once", "AgentGroupListController:_initData");
                    this.usersCollection = LEUserManagement.getDataManager().getUsersCollection();

                    var agentGroupsCollection = LEUserManagement.getDataManager().getAgentGroupsCollection();
                    this.selectableAgentGroupsCollection = SelectableCollectionDecorator.decorate(agentGroupsCollection);
                    this.agentGroupsOrganizedCollection = OrganizeCollectionDecorator.decorate(this.selectableAgentGroupsCollection, {
                        comparator: DEFAULT_COMPARATOR,
                        orderBy: DEFAULT_ORDERBY,
                        pageSize: PAGE_SIZE,
                        lazy: true
                    });

                    this.agentGroupsOrganizedCollection.reset();  //start the table collection empty until the first organize call, do not worry original is still full.

                    this.dataInitialized = true;
                }
            },

            _sortManagersByName: function(){
                LEUserManagement.logger.debug("_sortManagersByName", "AgentGroupListController:_sortManagersByName");
                this.selectableAgentGroupsCollection.each(function(group){
                    group.getManagers().sort(function(a, b){
                        return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                    });
                });
            },


            _initViews: function() {
                LEUserManagement.logger.debug("_initViews", "AgentGroupListController:_initViews");
                if (!this.viewInitialized) {
                    LEUserManagement.logger.debug("initing vies only once", "AgentGroupListController:_initViews");
                    var acUsersAccount = LE.siteSettings.accountSettings.isAcUser();
                    var exportAcUsersData = UserManagementUtilities.hasExportAcUsersData();
                    this.agentGroupsListLayout = new AgentGroupListLayout({
                        collection: this.agentGroupsOrganizedCollection,
                        displayAcUsersExport: (exportAcUsersData && acUsersAccount)
                    });
                    this.agentGroupsGridView = new AgentGroupsGridView({
                        collection:this.agentGroupsOrganizedCollection,
                        model: this.agentGroupsGridModel,
                        filters: AgentGroupListFilters,
                        comparators: AgentGroupListComparators,
                    });
                    this.viewInitialized = true;
                }
            },

            _bindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_bindEventsDataAndViews", "AgentGroupListController:_bindEventsDataAndViews");
                this.listenTo(this.agentGroupsOrganizedCollection ,"reset", this._onCollectionReset);
                this.agentGroupsOrganizedCollection.bindToOriginalCollectionEvents();

                this.listenTo(this.agentGroupsListLayout, "render", this._onLayoutRender);
                this.listenTo(this.agentGroupsListLayout, "show", this._onLayoutShown);  //listen to show not render ( we are using region add - this will trigger every time the view is seen )
                this.listenTo(this.agentGroupsListLayout, "close", this._onLayoutClose);

            },
            //happens once
            _onLayoutRender: function() {
                LEUserManagement.logger.debug("_onLayoutRender", "AgentGroupListController:_onLayoutRender");
                this.agentGroupsListLayout.gridRegion.show(this.agentGroupsGridView);
            },
            //happens every time
            _onLayoutShown: function() {
                LEUserManagement.logger.debug("_onLayoutShown", "AgentGroupListController:_onLayoutShown");
                this.agentGroupsOrganizedCollection.organize({filterModel:this.agentGroupsGridModel});
            },

            _onCollectionReset: function(collection, options) {
                LEUserManagement.logger.debug("_onCollectionReset", "AgentGroupListController:_onCollectionReset");
                this._handleActions();
                this._handleFooterButtonState();
            },

            _onPagingChange: function(currentPageNumber) {
                LEUserManagement.logger.debug("_onPagingChange", "AgentGroupListController:_onPagingChange");
                this.agentGroupsOrganizedCollection.organize({currentPage:currentPageNumber});
            },

            _onRowSelectorClick: function(options) {   //todo this function is doing work that should be done in the selectable collection - should be half it size
                LEUserManagement.logger.debug("_onRowSelectorClick", "AgentGroupListController:_onRowSelectorClick",options);
                var itemModel = options.itemModel;
                var isChecked = options.isChecked;

                if (isChecked) {
                    var currentSelectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                    if (!_.isEmpty(currentSelectedModel)) {
                        currentSelectedModel.trigger("model:selection:change", false);
                    }
                    this.agentGroupsOrganizedCollection.addToSelection(itemModel, {exclusively:true});
                    itemModel.trigger("model:selection:change", true);
                }
                else {
                    this.agentGroupsOrganizedCollection.deselectModel(itemModel);
                    this.channel.trigger("deselectModel",{model:itemModel});
                }
                this._handleActions();
                this._handleFooterButtonState();
            },

            _onRowClick: function(agentGroupModel) {
                LEUserManagement.logger.debug("_onRowClick", "AgentGroupListController:_onRowClick");
                this._navigateToAgentGroup(agentGroupModel.id);
            },

            _handleActions: function() {
                LEUserManagement.logger.debug("_handleActions", "AgentGroupListController:_handleActions");
                var selectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                var isAnyModelSelected = (!_.isEmpty(selectedModel));
                var isParentGroupSelected = (!_.isEmpty(selectedModel) && selectedModel.getParentGroupId() != null);
                //TODO (omar): Why are we sending 4 events?
                this.channel.trigger("actionMenu:set", {id:AgentGroupListLayout.ACTION_MENU_ITEMS.ADD, enabled:isAnyModelSelected});
                this.channel.trigger("actionMenu:set", {id:AgentGroupListLayout.ACTION_MENU_ITEMS.MOVE, enabled:isParentGroupSelected});
                this.channel.trigger("actionMenu:set", {id:AgentGroupListLayout.ACTION_MENU_ITEMS.EDIT, enabled:isAnyModelSelected});
                this.channel.trigger("actionMenu:set", {id:AgentGroupListLayout.ACTION_MENU_ITEMS.DELETE, enabled:isParentGroupSelected});
            },

            _handleFooterButtonState: function() {
                LEUserManagement.logger.debug("_handleFooterButtonState", "AgentGroupListController:_handleFooterButtonState");
                var selectedModels;
                if (this.agentGroupsOrganizedCollection) {
                    selectedModels = this.agentGroupsOrganizedCollection.getSelected();
                }
                this.channel.trigger("agentGroups:footer:change:buttonState", (selectedModels && selectedModels.length > 0));
            },

            _onActionMenuSelect: function(selectedItemId) {
                LEUserManagement.logger.debug("_onActionMenuSelect", "AgentGroupListController:_onActionMenuSelect");
                switch (selectedItemId) {
                    case AgentGroupListLayout.ACTION_MENU_ITEMS.ADD:
                        this._onAddSelected();
                        break;
                    case AgentGroupListLayout.ACTION_MENU_ITEMS.EDIT:
                        this._onEditSelected();
                        break;
                    case AgentGroupListLayout.ACTION_MENU_ITEMS.DELETE:
                        this._onDeleteSelected();
                        break;
                    case AgentGroupListLayout.ACTION_MENU_ITEMS.MOVE:
                        this._onMoveSelected();
                        break;
                    case AgentGroupListLayout.ACTION_MENU_ITEMS.EXPORT:
                        this._exportAllList();
                        break;
                }
            },


            _onAddSelected: function() {
                LEUserManagement.logger.debug("_onAddSelected", "AgentGroupListController:_onAddSelected");
                var selectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    LEUserManagement.router.navigate("agentGroups/"+ selectedModel.get("id") +"/" + CONST.ROUTING.NEW_ITEM_ID);
                }
            },

            _onEditSelected: function() {
                LEUserManagement.logger.debug("_onEditSelected", "AgentGroupListController:_onEditSelected");
                var selectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    this._navigateToAgentGroup(selectedModel.get("id"));
                }
            },

            _onDeleteSelected: function() {
                LEUserManagement.logger.debug("_onDeleteSelected", "AgentGroupListController:_onDeleteSelected");
                var selectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    var message = LE.translator.translate({
                        key: "LEUserManagement.agentGroupList.delete.confirm.text",
                        args: [{key: SecureUtilities.escapeForHtmlContent(selectedModel.getName()), isTranslate:false}]
                    });

                    LEUserManagement.notifier.showConfirm({
                        title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                        content: message,
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.delete"),
                            callback: _.bind(this._onDeleteConfirmed, this)
                        }
                    });
                }
            },

            _onDeleteConfirmed: function() {
                LEUserManagement.logger.debug("_onDeleteConfirmed", "AgentGroupListController:_onDeleteConfirmed");
                var selectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {

                    LEUserManagement.showLoader();
                    selectedModel.destroy({
                        success: _.bind(this._onDeleteSuccess, this),
                        error: _.bind(this._onDeleteError, this),
                        wait: true
                    });
                }
            },

            _onDeleteSuccess: function(model, resp, options) {
                LEUserManagement.logger.debug("_onDeleteSuccess", "AgentGroupListController:_onDeleteSuccess");
                LEUserManagement.closeLoader();
                this.agentGroupsOrganizedCollection.clearSelection();    //todo clear selection,deselect model should be done in the selectable collection
                this._deselectModel();
                this._handleFooterButtonState();
                this._removeSubGroupFromParent(model);

                //In order to refresh the list of groups. (might need to change this)
                this.agentGroupsOrganizedCollection.trigger("reset");
            },

            _onDeleteError: function(model, resp, options) {
                LEUserManagement.logger.info("_onDeleteError", "AgentGroupListController:_onDeleteError",resp);
                LEUserManagement.closeLoader();

                var errorMessageText = LE.translator.translate({
                    key: "LEUserManagement.agentGroupList.error.delete.general",
                    args: [{key: model.getName(), isTranslate: false}]
                });
                if (resp && resp.responseError && resp.responseError.internalCode) {
                    var errorCode = resp.responseError.internalCode;
                    var fields = resp.responseError.fields;

                    if (errorCode === 14 && fields) {
                        if (fields.length > 1) {
                            errorMessageText = LE.translator.translate("LEUserManagement.agentGroupList.error.delete.dependency.multi");
                        } else if (fields.indexOf("members") > -1){
                            errorMessageText = LE.translator.translate("LEUserManagement.agentGroupList.error.delete.dependency.members");
                        } else if (fields.indexOf("managers") > -1){
                            errorMessageText = LE.translator.translate("LEUserManagement.agentGroupList.error.delete.dependency.managers");
                        } else if (fields.indexOf("sub-groups") > -1){
                            errorMessageText = LE.translator.translate("LEUserManagement.agentGroupList.error.delete.dependency.subGroups");
                        } else if (fields.indexOf("skills") > -1){
                            errorMessageText = LE.translator.translate("LEUserManagement.agentGroupList.error.delete.dependency.skills");
                        }
                    } else if (errorCode === 208) {
                        //A general error will be shows as this use case is blocked in the UI
                        //errorMessageText = LE.translator.translate("LEUserManagement.agentGroupList.error.delete.parent.group");
                    }
                }
                LEUserManagement.notifier.showError({"content":errorMessageText,"timeToShow":10000});
            },

            _removeSubGroupFromParent: function(model) {
                var parentId = model.getParentGroupId();
                var parentModel = this.agentGroupsOrganizedCollection.get(parentId);
                parentModel.removeSubGroup(model.get("id"));
            },

            _onMoveSelected: function() {
                LEUserManagement.logger.debug("_onMoveSelected", "AgentGroupListController:_onMoveSelected");
                var selectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                if (!_.isEmpty(selectedModel)) {
                    LEUserManagement.router.navigate("agentGroups/" + selectedModel.get("id") + "/move");
                }
            },

            _exportAllList: function() {
                LEUserManagement.logger.debug("_exportAllList", "AgentGroupListController:_exportAllList");
                UserManagementUtilities.exportAllList();
            },

            _onLayoutClose: function() {
                LEUserManagement.logger.debug("_onLayoutClose", "AgentGroupListController:_onLayoutClose");
                this._unbindEventsDataAndViews();
            },

            _unbindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_unbindEventsDataAndViews", "AgentGroupListController:_unbindEventsDataAndViews");
                if (this.agentGroupsListLayout) {
                    this.stopListening(this.agentGroupsListLayout);
                }
                if (this.agentGroupsOrganizedCollection) {
                    this.stopListening(this.agentGroupsOrganizedCollection);
                    this.agentGroupsOrganizedCollection.unBindFromOriginalCollectionEvents();
                }
            },

            _onNavigateOut: function(){
                this._unbindEventsDataAndViews();
            },

            _navigateToAgentGroup: function(agentGroupId) {
                LEUserManagement.logger.debug("_navigateToAgentGroup", "AgentGroupListController:_navigateToAgentGroup");
                LEUserManagement.router.navigate("agentGroups/"+agentGroupId);
            },

            _deselectModel: function(options) {
                LEUserManagement.logger.debug("_deselectModel", "AgentGroupListController:_deselectModel");
                var selectedModel;
                if (options) {
                    selectedModel = options.model;
                } else if (this.agentGroupsOrganizedCollection) {
                    selectedModel = this.agentGroupsOrganizedCollection.getSelectedModel();
                }
                if (selectedModel) {//In case the user edited an agent group without checking it
                    this.agentGroupsOrganizedCollection.deselectModel(selectedModel, {silent:true});
                    selectedModel.trigger("model:selection:change", false);
                }
               this._handleFooterButtonState();
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupListController;
});



